import { useEffect, useState } from 'react'
import { get, post } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import { FaPlus } from "react-icons/fa6";
import menu_icon from '../../../resources/more-vertical.png'
import calories_icon from '../../../resources/calories.svg'
import carb_icon from '../../../resources/Group 1000003402.svg'
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'

import './TodayMeal.css'
import TodayMealMenu from './menu_items';
import AddMeal from '../../AddMeal/AddMeal';

function TodayMeal({ currentUser, userConfig, setEditMeal }) {
    const [meals, setMeals] = useState([])
    const today = yyyy_mm_dd_date_format({})
    const [mealMenuIndex, setMealMenuIndex] = useState()
    const [totalCalories, setTotalCalories] = useState(0)
    const [groupedCalories, setGroupedCalories] = useState([])

    const [modalOpen, setModalOpen] = useState(false)
    const [selectedModal, setSelectedModal] = useState('default')
    const [modalBreakfastOpen, setModalBreakFastOpen] = useState(false)
    const [modalLunchOpen, setModalLunchOpen] = useState(false)
    const [modalDinnerOpen, setModalDinnerOpen] = useState(false)
    const [modalSnackOpen, setModalSnackOpen] = useState(false)

    const [replaceUserMealId, setReplaceUserMealId] = useState()

    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    useEffect(() => {
        if (userConfig)
            get_user_daily_meal_plan()
    }, [modalOpen, modalBreakfastOpen, modalDinnerOpen, modalLunchOpen, modalSnackOpen])

    useEffect(() => {
        if (userConfig)
            get_user_daily_meal_plan()
    }, [userConfig])

    async function get_user_daily_meal_plan() {
        try {
            const resp = await get("/api/user/get-user-daily-meal-plan", {
                user_id: currentUser.uid,
                date: today
            })

            const order = ['breakfast', 'lunch', 'dinner', 'snack']; // Define priority order

            resp.sort((a, b) => {
                const indexA = order.indexOf(a.course);
                const indexB = order.indexOf(b.course);

                // If course is not in the order array, put it at the end
                return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
            });

            setMeals(resp)

            // get total calories
            setTotalCalories(resp.reduce((sum, item) => sum + parseInt(item.total_calories), 0))

            const mealColors = {
                breakfast: '#299257', // Gold
                lunch: '#FE9539', // Tomato
                dinner: 'rgba(109, 170, 214, 0.5', // SteelBlue
                snack: '#C5A3FF',
                other: '#96948F' // BlueViolet (or whatever meal categories you have)
            };

            // group calories
            const today_meals = Object.entries(
                resp.reduce((acc, item) => {
                    const meal = item.course; // e.g., 'breakfast', 'lunch', snack, etc.

                    // Initialize if not already present
                    if (!acc[meal]) {
                        acc[meal] = 0;
                    }

                    // Add the calories to the corresponding meal course
                    acc[meal] += parseInt(item.total_calories);

                    return acc;
                }, {})
            ).map(([meal, calories]) => ({
                meal_course: meal,
                total_calories: calories,
                background_color: mealColors[meal] || '#FFFFFF' // Default to white if not found
            }));
            setGroupedCalories(today_meals)
        } catch (e) {
            // Could not fetch user meal plan or no meal plan is schedualed
            setMeals([])
        }
    }

    async function userLikeMeal(meal_id) {
        try {
            await post("/api/meal/user-like-meal", { meal_id: meal_id, user_id: currentUser.uid })
            // Get meals again
            get_user_daily_meal_plan()
        } catch {
            alert("An error occured while liking meal")
        }
    }
    async function userDislikeMeal(meal_id) {
        try {
            await post("/api/meal/user-dislike-meal", { meal_id: meal_id, user_id: currentUser.uid })
            // Get meals again
            get_user_daily_meal_plan()
        } catch {
            alert("An error occured while disliking meal")
        }
    }

    async function userFavoriteMeal(meal_id) {
        try {
            await post("/api/meal/user-favorite-meal", { meal_id: meal_id, user_id: currentUser.uid })
            // Get meals again
            get_user_daily_meal_plan()
        } catch {
            alert("An error occured while favoriting meal")
        }
    }

    return (
        <div className="component_padding black component_full_height">
            <div className='flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>Today’s Meal</h4>

                <div className='dashboard-water-consumption-input-amount-plus-minus flex align_center justify_center' onClick={() => { setModalOpen(true); }}>
                    <FaPlus size={18} color='#235539' />
                </div>

                {/* {
                  modalOpen &&  <AddMeal modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        selectedDate={today}
                        selectedCourse={selectedModal === 'default' ? null : selectedModal}
                        replaceUserMealId={selectedModal === 'default' ? null : replaceUserMealId}
                    />
                } */}
                {
                    modalOpen && <AddMeal modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        selectedDate={today}
                    />
                }
                {
                    modalBreakfastOpen && <AddMeal modalOpen={modalBreakfastOpen} setModalOpen={setModalBreakFastOpen} selectedDate={today} selectedCourse={'breakfast'} replaceUserMealId={replaceUserMealId} />
                }
                {
                    modalLunchOpen && <AddMeal modalOpen={modalLunchOpen} setModalOpen={setModalLunchOpen} selectedDate={today} selectedCourse={'lunch'} replaceUserMealId={replaceUserMealId} />
                }
                {
                    modalDinnerOpen && <AddMeal modalOpen={modalDinnerOpen} setModalOpen={setModalDinnerOpen} selectedDate={today} selectedCourse={'dinner'} replaceUserMealId={replaceUserMealId} />
                }
                {
                    modalSnackOpen && <AddMeal modalOpen={modalSnackOpen} setModalOpen={setModalSnackOpen} selectedDate={today} selectedCourse={'snack'} replaceUserMealId={replaceUserMealId} />
                }
            </div>

            <div className='component_heading_separating_line'></div>

            <div className='dashboard-today-meal-main-div flex flex_column justify_space_between'>
                <div className='flex flex_column gap_12'>
                    {meals.map((meal, i) => (
                        <div key={i}>
                            <div className={meal.course + '-today-meal-outer-color' + ' dashboard-today-meal-div flex justify_space_between align_center gap_12'}>
                                <div className={meal.course + '-today-meal-inner-color' + ' dashboard-today-meal-detail-div width_100 flex align_start justify_space_between gap_20'}>
                                    <div className='flex flex_column justify_space_between gap_10 cursor_pointer' onClick={() => goToPage('/meal-details/' + meal.meal_id)}>
                                        <div>
                                            <p className='font_size_16 font_weight_600'>{meal.course.charAt(0).toUpperCase() + meal.course.slice(1)}</p>
                                        </div>
                                        <div className='flex align_center gap_8'>
                                            <div className='flex gap_6 align_center'>
                                                <p className='font_size_14 gray_scale_2'>{meal.name}</p>
                                            </div>
                                            <div className='flex gap_6 align_center'>
                                                <p className='font_size_14 gray_scale_2'>|</p>
                                            </div>
                                            <div className='flex gap_6 align_center'>
                                                <p className='font_size_14 gray_scale_2'>
                                                    ${Math.round(meal.cost)}
                                                    <sub> {"(per serving)"} </sub>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex_column justify_space_between align_end gap_10'>
                                        <div>
                                            <p className='font_size_14 gray_scale_2'>{parseInt(meal.total_calories)} Cal</p>
                                        </div>
                                        <div className='flex align_center gap_12'>
                                            <div className='cursor_pointer' onClick={() => userLikeMeal(meal.meal_id)}>
                                                {meal.like ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path fill-rule="evenodd" clipRule="evenodd" d="M15.8052 5.51798C16.2934 5.74067 16.7281 6.06567 17.0798 6.47096C17.433 6.87567 17.695 7.35162 17.8481 7.86653C18.0012 8.38144 18.0418 8.92326 17.967 9.45521L17.4382 13.2052C17.3082 14.0984 16.8618 14.9152 16.1803 15.5071C15.4989 16.0989 14.6276 16.4265 13.725 16.4302H6V4.74296L7.2195 2.27171C7.46082 1.78152 7.87032 1.3944 8.37328 1.18097C8.87625 0.96754 9.43918 0.942018 9.9594 1.10906C10.4796 1.2761 10.9225 1.62457 11.2071 2.09092C11.4918 2.55727 11.5994 3.11041 11.5103 3.64946L11.2583 5.18021H14.25C14.7866 5.1801 15.317 5.29529 15.8052 5.51798ZM0 13V9.25C0.00119063 8.2558 0.396661 7.30267 1.09966 6.59967C1.80267 5.89666 2.7558 5.50119 3.75 5.5H4.5V16.75H3.75C2.7558 16.7488 1.80267 16.3533 1.09966 15.6503C0.396661 14.9473 0.00119063 13.9942 0 13Z" fill="url(#paint0_linear_333_5160)" />
                                                        <defs>
                                                            <linearGradient id="paint0_linear_333_5160" x1="4.88353" y1="3.85908" x2="16.162" y2="18.2274" gradientUnits="userSpaceOnUse">
                                                                <stop stopColor="#235539" />
                                                                <stop offset="1" stopColor="#7B946B" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path fill-rule="evenodd" clipRule="evenodd" fill={"#C5C1B9"} d="M15.8052 5.51798C16.2934 5.74067 16.7281 6.06567 17.0798 6.47096C17.433 6.87567 17.695 7.35162 17.8481 7.86653C18.0012 8.38144 18.0418 8.92326 17.967 9.45521L17.4382 13.2052C17.3082 14.0984 16.8618 14.9152 16.1803 15.5071C15.4989 16.0989 14.6276 16.4265 13.725 16.4302H6V4.74296L7.2195 2.27171C7.46082 1.78152 7.87032 1.3944 8.37328 1.18097C8.87625 0.96754 9.43918 0.942018 9.9594 1.10906C10.4796 1.2761 10.9225 1.62457 11.2071 2.09092C11.4918 2.55727 11.5994 3.11041 11.5103 3.64946L11.2583 5.18021H14.25C14.7866 5.1801 15.317 5.29529 15.8052 5.51798ZM0 13V9.25C0.00119063 8.2558 0.396661 7.30267 1.09966 6.59967C1.80267 5.89666 2.7558 5.50119 3.75 5.5H4.5V16.75H3.75C2.7558 16.7488 1.80267 16.3533 1.09966 15.6503C0.396661 14.9473 0.00119063 13.9942 0 13Z" />
                                                    </svg>
                                                )}
                                            </div>
                                            <div className='cursor_pointer' onClick={() => userDislikeMeal(meal.meal_id)}>
                                                {meal.like === false ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path fill-rule="evenodd" clipRule="evenodd" d="M2.19823 13.0721C1.71002 12.8495 1.27535 12.5245 0.923668 12.1192C0.570425 11.7145 0.308369 11.2385 0.155281 10.7236C0.00219345 10.2087 -0.0383453 9.66687 0.0364189 9.13491L0.565168 5.38491C0.695232 4.49173 1.1416 3.6749 1.82307 3.08304C2.50454 2.49118 3.37582 2.16361 4.27842 2.15991H12.0034V13.8472L10.7839 16.3184C10.5426 16.8086 10.1331 17.1957 9.63014 17.4092C9.12717 17.6226 8.56424 17.6481 8.04402 17.4811C7.5238 17.314 7.08096 16.9656 6.79627 16.4992C6.51158 16.0329 6.404 15.4797 6.49317 14.9407L6.74517 13.4099H3.75342C3.21681 13.41 2.68645 13.2948 2.19823 13.0721ZM18.0034 10.1599V6.40991C18.0022 5.41572 17.6068 4.46258 16.9038 3.75958C16.2007 3.05657 15.2476 2.6611 14.2534 2.65991H13.5034V13.9099H14.2534C15.2476 13.9087 16.2007 13.5133 16.9038 12.8102C17.6068 12.1072 18.0022 11.1541 18.0034 10.1599Z" fill="url(#paint0_linear_380_5165)" />
                                                        <defs>
                                                            <linearGradient id="paint0_linear_380_5165" x1="9.00169" y1="2.15991" x2="9.00169" y2="17.5901" gradientUnits="userSpaceOnUse">
                                                                <stop stopColor="#235539" />
                                                                <stop offset="1" stopColor="#7B946B" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path fill-rule="evenodd" clipRule="evenodd" fill={"#C5C1B9"} d="M2.19823 13.0721C1.71002 12.8495 1.27535 12.5245 0.923668 12.1192C0.570425 11.7145 0.308369 11.2385 0.155281 10.7236C0.00219345 10.2087 -0.0383434 9.66687 0.0364189 9.13491L0.565168 5.38491C0.695234 4.49173 1.1416 3.6749 1.82307 3.08304C2.50454 2.49118 3.37582 2.16361 4.27842 2.15991H12.0034V13.8472L10.7839 16.3184C10.5426 16.8086 10.1331 17.1957 9.63014 17.4092C9.12717 17.6226 8.56424 17.6481 8.04402 17.4811C7.5238 17.314 7.08096 16.9656 6.79627 16.4992C6.51158 16.0329 6.404 15.4797 6.49317 14.9407L6.74517 13.4099H3.75342C3.21681 13.41 2.68645 13.2948 2.19823 13.0721ZM18.0034 10.1599V6.40991C18.0022 5.41572 17.6068 4.46258 16.9038 3.75958C16.2007 3.05657 15.2476 2.6611 14.2534 2.65991H13.5034V13.9099H14.2534C15.2476 13.9087 16.2007 13.5133 16.9038 12.8102C17.6068 12.1072 18.0022 11.1541 18.0034 10.1599Z" />
                                                    </svg>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <TodayMealMenu i={i} meal={meal} mealMenuIndex={mealMenuIndex} setMealMenuIndex={setMealMenuIndex}
                                    userFavoriteMeal={userFavoriteMeal} setEditMeal={setEditMeal} setReplaceUserMealId={setReplaceUserMealId}
                                    setModalOpen={meal.course == 'breakfast' ? setModalBreakFastOpen : (meal.course == 'lunch' ? setModalLunchOpen : meal.course == 'dinner' ? setModalDinnerOpen : meal.course === 'snack' ? setModalSnackOpen : null)} />
                            </div>
                        </div>
                    ))}
                </div>

                <div className='dashboard-today-meal-calory-div align_center gap_20'>
                    <p className='gray_scale_2'>Daily Consumption</p>
                    <div className='dashboard-today-meal-calory-bar-div width_100 flex align_center gap_3'>
                        {groupedCalories.map((group, i) => (
                            <div
                                key={i}
                                style={{ width: (group.total_calories * 100 / totalCalories) + '%', background: group.background_color }}
                                className='dashboard-today-meal-calory-indiv-bar-div height_100'
                                data-tooltip-id="today-calory-tooltip" data-tooltip-content={`${group.total_calories} Cal`}
                            ></div>
                        ))}
                    </div>

                    <Tooltip id="today-calory-tooltip" />

                    <p className='gray_scale_2'>{totalCalories} Cal</p>
                </div>
            </div>
        </div >
    );
}


export default TodayMeal;